import React from 'react';
import Form from 'components/form';
import CategoryInputNew from 'components/input/CategoryInput';

export default function CategoryField(props) {
  return <Form.Field {...props} component={CategoryInputNew} />;
}
